import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  open(event: Event) {
    const button = event.currentTarget as HTMLElement;
    const id = button.dataset.modalId;

    const modal = document.getElementById(id!);
    modal?.classList.remove("hidden");
  }

  close(event: Event) {
    const modal = (event.currentTarget as HTMLElement).closest("[data-modal='dialog']");

    modal?.classList.add("hidden");
  }
}
